export default __webpack_public_path__ + "static/media/news-17.9a3441c5.jpeg";